declare global {
    interface Window {
        _paq?: Array<unknown[]>
    }
}

const MATOMO_URL = import.meta.env.VITE_MATOMO_URL ?? 'https://curious-company.matomo.cloud/'
const MATOMO_SITE_ID = String(import.meta.env.VITE_MATOMO_SITE_ID ?? '5')
const MATOMO_SCRIPT_URL = import.meta.env.VITE_MATOMO_SCRIPT_URL ?? 'https://cdn.matomo.cloud/curious-company.matomo.cloud/matomo.js'

export function initMatomo() {
    if (typeof window === 'undefined') return
    if (!MATOMO_URL || !MATOMO_SITE_ID) return
    if (document.getElementById('matomo-script')) return

    window._paq = window._paq ?? []
    window._paq.push(['disableCookies'])
    window._paq.push(['trackPageView'])
    window._paq.push(['enableLinkTracking'])
    window._paq.push(['setTrackerUrl', `${MATOMO_URL}matomo.php`])
    window._paq.push(['setSiteId', MATOMO_SITE_ID])

    const script = document.createElement('script')
    script.id = 'matomo-script'
    script.async = true
    script.src = MATOMO_SCRIPT_URL
    document.head.appendChild(script)
}
